import {IProduct} from 'modules/product-card/models/ProductResponse';
import {IProperty, IPropertyValue} from 'modules/products/types';
import {getProductCanonSection} from 'modules/product-card/helpers';

interface IGetTaninsTitleProps {
    titleAromaticity: string;
    titleTanins: string;
}

interface IListItem {
    additionalData?: IGetTaninsTitleProps;
    code: string;
    title: string;
}

export interface IResultProductTasteCharacteristic {
    code: string;
    title: string;
    value: number;
}

// коды канонической секции
const VISKI = 'viski';
const KONYAK = 'konyak';
const ARMANYAK = 'armanyak';
const BRENDI = 'brendi';
const VINO = 'vino';
const SHAMPANSKOE = 'shampanskoe';
const IGRISTOE_VINO = 'igristoe-vino';

// Коды вкусовых характеристик
const SMOKINESS = 'smokiness';
const SWEETNESS = 'sweetness';
const BODIED = 'bodied';
const SPICE = 'spice';
const COLORNESS = 'colorness';
const WOODINESS = 'woodiness';
const ACIDITY = 'acidity';
const TANINS = 'tanins';
const RICHNESS = 'richness';
const FRUITINESS = 'fruitiness';

// Код цветовой характеристики
const COLOR = 'color';

const RED = 'красное';

const TASTE_CHARACTERISTICS_VISKI = [
    {
        code: SMOKINESS,
        title: 'Дымный',
    },
    {
        code: SWEETNESS,
        title: 'Фруктовый',
    },
    {
        code: BODIED,
        title: 'Медовый',
    },
    {
        code: RICHNESS,
        title: 'Пряный',
    },
];

const TASTE_CHARACTERISTICS_KONYAK = [
    {
        code: SPICE,
        title: 'Пряный',
    },
    {
        code: FRUITINESS,
        title: 'Фруктовый',
    },
    {
        code: COLORNESS,
        title: 'Цветочный',
    },
    {
        code: WOODINESS,
        title: 'Древесный',
    },
];

const TASTE_CHARACTERISTICS_VINO = [
    {
        code: SWEETNESS,
        title: 'Сладость',
    },
    {
        code: ACIDITY,
        title: 'Кислотность',
    },
    {
        additionalData: {
            titleAromaticity: 'Ароматичность',
            titleTanins: 'Танины',
        },
        code: TANINS,
        title: '',
    },
    {
        code: BODIED,
        title: 'Тело',
    },
];

const getTasteCharacteristicsList = (canonSection: string): IListItem[] => {
    switch (canonSection) {
        case VISKI:
            return TASTE_CHARACTERISTICS_VISKI;
        case KONYAK:
        case ARMANYAK:
        case BRENDI:
            return TASTE_CHARACTERISTICS_KONYAK;
        case VINO:
        case SHAMPANSKOE:
        case IGRISTOE_VINO:
            return TASTE_CHARACTERISTICS_VINO;
        default:
            return [];
    }
};

const getTaninsTitle = (
    {titleAromaticity, titleTanins}: IGetTaninsTitleProps,
    productProperties: IProperty[],
): string => {
    const colorProperty = productProperties.find((data) => data.code === COLOR);

    if (!colorProperty) {
        return titleAromaticity;
    }

    const isRed = (colorProperty.value as IPropertyValue).id.toLowerCase() === RED;
    return isRed ? titleTanins : titleAromaticity;
};

// Подробнее
// https://conf.awg.ru/pages/viewpage.action?pageId=194846052#UC49%D0%9F%D1%80%D0%BE%D1%81%D0%BC%D0%BE%D1%82%D1%80%D1%85%D0%B0%D1%80%D0%B0%D0%BA%D1%82%D0%B5%D1%80%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D1%82%D0%BE%D0%B2%D0%B0%D1%80%D0%B0-FR-1
export const getProductTasteCharacteristics = (product: IProduct): IResultProductTasteCharacteristic[] => {
    const canonSection = getProductCanonSection(product.sections);
    const list = getTasteCharacteristicsList(canonSection.code);
    const productProperties = product.properties;
    const resultProductTasteCharacteristics: IResultProductTasteCharacteristic[] = [];

    if (list.every(({code}) => 0 === productProperties.find((data) => data.code === code)?.value)) {
        return [];
    }

    list.forEach(({additionalData, code, title}) => {
        const property = productProperties.find((data) => data.code === code);

        if (property) {
            const value = property.value as number;

            if (code === TANINS) {
                const taninsTitle = getTaninsTitle(additionalData as IGetTaninsTitleProps, productProperties);

                resultProductTasteCharacteristics.push({
                    code,
                    title: taninsTitle,
                    value,
                });

                return;
            }

            resultProductTasteCharacteristics.push({
                code,
                title,
                value,
            });
        }
    });

    return resultProductTasteCharacteristics;
};
